import { getCurrentYear } from '../../../../../../utils/utility-functions';

const excludeNonNumericValues = (caseNumber: string) => {
  return caseNumber.replace(/\D/g, '');
};

const buildTransformedString = (numericValue: string) => {
  const yearOfCase = numericValue.slice(0, 2);

  const caseIds = numericValue.slice(2);

  return { yearOfCase, caseIds };
};

const isYearValid = (yearToCheck: string): boolean => {
  const currentYear = getCurrentYear();

  const year = parseInt(yearToCheck) + 2000;

  if (year <= currentYear) {
    return true;
  }

  return false;
};

const trimCaseNumberByType = (
  caseNumber: string,
  type: 'short' | 'short-bk' | 'long' | 'long-bk',
): string => {
  switch (type) {
    case 'short':
      return caseNumber.slice(0, 8);
    case 'short-bk':
      return caseNumber.slice(0, 11);
    case 'long':
      return caseNumber.slice(0, 10);
    case 'long-bk':
      return caseNumber.slice(0, 13);
    default:
      return '';
  }
};

const formatShortNumber = (str: string): string => {
  const trimmedCaseNumber = trimCaseNumberByType(
    str,
    str.split('-bk-').length > 1 ? 'short-bk' : 'short',
  );

  const numericCaseNumber = excludeNonNumericValues(trimmedCaseNumber);

  const { yearOfCase, caseIds } = buildTransformedString(numericCaseNumber);

  const isInputtedYearValid = isYearValid(yearOfCase);

  if (!isInputtedYearValid) {
    return '';
  }

  return `1-${yearOfCase}-bk-${caseIds}`;
};

const formatLongNumber = (str: string): string => {
  const trimmedCaseNumber = trimCaseNumberByType(
    str,
    str.split('-bk-').length > 1 ? 'long-bk' : 'long',
  );

  const monthCase = trimmedCaseNumber[0];

  const numericCaseNumber = excludeNonNumericValues(trimmedCaseNumber);

  //we are excluding the first character because it reflects the year and it would cause a bug in the transformedString
  const yearAndDigits = numericCaseNumber.slice(1, 10);

  const { yearOfCase, caseIds } = buildTransformedString(yearAndDigits);

  const isInputtedYearValid = isYearValid(yearOfCase);

  if (!isInputtedYearValid) {
    return '';
  }

  // Add your long format transformation logic here
  return `${monthCase}:${yearOfCase}-bk-${caseIds}`;
};

const transformValidCaseNumber = (
  caseNumber: string,
  format: 'short' | 'long',
): string => {
  const formatMapper = {
    short: () => formatShortNumber(caseNumber),
    long: () => formatLongNumber(caseNumber),
  };

  const formattedNumber = formatMapper[format]();

  return formattedNumber;
};

export const transformCaseNumber = (caseNumber: string): string => {
  const monthDigitsFormat = /^\d{2}(-bk)?-\d{5,}[\w-]*$/;
  const yearMonthDigitsFormat = /^\d:\d{2}(-bk)?-\d{5,}[\w-]*$/;

  let formattedNumber = '';

  if (monthDigitsFormat.test(caseNumber)) {
    // Transform for the normal (short) format
    formattedNumber = transformValidCaseNumber(caseNumber, 'short');
  } else if (yearMonthDigitsFormat.test(caseNumber)) {
    // Transform for the full (long) format
    formattedNumber = transformValidCaseNumber(caseNumber, 'long');
  }

  return formattedNumber;
};
